import { model } from '../core/model'

const tagRecording = (tag) => {
  try {
    if (window.hj) {
      window.hj('tagRecording', tag);
    }
    else {
      model.Window.hotjarTags.push(tag);
    }
  }
  catch (e) { }
}

const callTrigger = (label) => {
  if (window.hj) {
    window.hj('trigger', label);
  }
  else {
    model.Window.hotjarTriggers.push(label);
  }
}


const pushDelayed = () => {
  if (window.hj) {
    model.Window.hotjarTags.forEach(element => {
      tagRecording(element)
    });
    model.Window.hotjarTriggers.forEach(element => {
      callTrigger(element)
    });
  }
}

module.exports = {
  tagRecording,
  callTrigger,
  pushDelayed
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/hotjar.js